// <Container grid="main" color="111" margin-top="10">etc...

import React from "react"

const Container = ({children, style, grid, classes}) => {
  
  let className = 'grid-main'
  if (grid) {
    className = 'grid-' + grid
  }
  let containerClassName = className + '--container'
  let allClasses = className + ' ' + classes

  // let className = 'grid-main'
  // let containerClassName = className + '--container'

  return (
  <>

    <div className={containerClassName}>
      <div className={allClasses} style={style}>
          <div></div>
          <div>
            {children}
          </div>
          <div></div>
        </div>
    </div>
    
  </>
)}

export default Container